import React, { useState } from 'react';
import { Dialog, Button, Typography, ButtonGroup, Chip, TextField } from '@material-ui/core';
import { Add, Remove } from '@material-ui/icons';
import { useDispatch, useSelector } from 'react-redux';
import useWindowDimensions from '../../hooks/useWindowDimensions';
import RASimpleForm from './RASimpleForm';
import { setSnackbar, setData, setItsMaterialDialog } from '../redux';
import { sortByDate } from '../../helperFunctions';

export default () => {
  const { width } = useWindowDimensions();
  const dispatch = useDispatch();
  const data = useSelector(state => state.tasks.data);
  const itsMaterialDialog = useSelector(state => state.tasks.itsMaterialDialog);
  const [rows, setRows] = useState([]);

  const isInstaledMaterials = itsMaterialDialog.isInstaledMaterials;
  const task = itsMaterialDialog.task;

  if (rows.length === 0) {
    let row = { id: 1, materialTypeName: '', serialNumber: '', condition: '' };
    setRows([...rows, row]);
  }

  const smallerFontSize = width <= 500 ? '3.5vw' : '18px';

  const addMaterial = () => {
    let row = {};
    if (rows.length >= 1) {
      row.id = rows[rows.length - 1].id + 1;
      row.materialTypeId = '';
      row.materialId = '';
      row.condition = '';
    }
    setRows([...rows, row]);
  };

  const removeMaterial = id => {
    let rowsToUpdate = rows.filter(x => x.id !== id);
    setRows([...rowsToUpdate]);
  };

  const saveItsMaterials = isInstaledMaterials => {
    if (!isInstaledMaterials) {
      updateMaterials(task.itsUninstaledMaterials, false);
    }

    setRows([]);
  };

  const updateMaterials = (materialsToAdd, isInstaledMaterial) => {
    const updatedMaterialsToAdd = [...materialsToAdd];
    rows.forEach(r => {
      const materialRow = updatedMaterialsToAdd.find(m =>
        m.materialSerialNumber.includes(r.serialNumber)
      );
      if (materialRow) {
        dispatch(
          setSnackbar({
            open: true,
            message: `Материал със сериен номер ${r.serialNumber} вече е добавен!`,
          })
        );
        return;
      } else {
        const newObject = {
          materialSerialNumber: r.serialNumber,
          materialTypeName: r.materialTypeName,
          materialCondition: r.condition,
          taskId: task.id,
        };
        updatedMaterialsToAdd.push(newObject);
      }
    });

    const tasks = [...data.tasks];
    const taskIndex = data.tasks.indexOf(data.tasks.find(x => x.id === task.id));
    if (!isInstaledMaterial) {
      tasks.splice(taskIndex, 1, {
        ...task,
        itsUninstaledMaterials: updatedMaterialsToAdd,
      });
    }

    dispatch(
      setData({
        ...data,
        tasks: tasks.sort((a, b) => sortByDate(a, b)),
      })
    );
  };

  const validateInput = () => {
    let message = '';
    const rowHasInvalidMaterialTypeName = rows.find(r => !r.materialTypeName);
    if (rowHasInvalidMaterialTypeName) {
      message = `Моля, попълнете поле Тип на материал за материал номер ${rowHasInvalidMaterialTypeName.id} .`;
      return message;
    }

    const rowHasInvalidMaxLenghtForMaterialType = rows.find(r => r.materialTypeName.length > 100);
    if (rowHasInvalidMaxLenghtForMaterialType) {
      message = `Моля, попълнете поле Тип на материал за материал номер ${rowHasInvalidMaxLenghtForMaterialType.id} .`;
      return message;
    }

    const rowWithInvalidSerialNumber = rows.find(r => !r.serialNumber);
    if (rowWithInvalidSerialNumber) {
      message = `Моля, добавете сериен номер за материал номер ${rowWithInvalidSerialNumber.id}!`;
      return message;
    }

    const rowWithInvalidMaxLenghtOfSerialNumber = rows.find(r => r.serialNumber.length > 1000);
    if (rowWithInvalidMaxLenghtOfSerialNumber) {
      message = `Максималната дължина на поле за сериен номер за материал номер ${rowWithInvalidMaxLenghtOfSerialNumber.id} е 1000 символа!`;
      return message;
    }

    const rowWithMultipleSerialNumbers = rows.find(
      r => r.serialNumber.length > 17 && !r.serialNumber.includes(',')
    );
    if (rowWithMultipleSerialNumbers) {
      message = `Серийните номера трябва да бъдат разделени със запетая за материал номер ${rowWithMultipleSerialNumbers.id}!`;
      return message;
    }

    const rowWithoutCondition = rows.find(r => !r.condition);
    if (rowWithoutCondition) {
      message = `Моля, попълнете Състояние за материал за материал номер ${rowWithoutCondition.id}.`;
    }

    const rowWithConditionInvalidMaxLenght = rows.find(r => r.condition.length > 1000);
    if (rowWithConditionInvalidMaxLenght) {
      message = `Максималната дължина за Състояние за материал за номер материал ${rowWithConditionInvalidMaxLenght.id} е 1000 символа.`;
    }
    return message;
  };

  const saveMaterialTypeName = (event, rowId) => {
    const materialTypeName = event.target.value;
    const itemIndex = rows.findIndex(r => r.id === rowId);
    if (itemIndex !== -1) {
      const newRows = [...rows];
      newRows[itemIndex] = { ...newRows[itemIndex], materialTypeName: materialTypeName };
      setRows(newRows);
    }
  };

  const saveMaterialSerialNumber = (event, rowId) => {
    const serialNumber = event.target.value;
    const itemIndex = rows.findIndex(r => r.id === rowId);
    if (itemIndex !== -1) {
      const newRows = [...rows];
      newRows[itemIndex] = { ...newRows[itemIndex], serialNumber: serialNumber };
      setRows(newRows);
    }
  };

  const savеCondition = (event, rowId) => {
    const condition = event.target.value;
    const itemIndex = rows.findIndex(r => r.id === rowId);
    if (itemIndex !== -1) {
      const newRows = [...rows];
      newRows[itemIndex] = { ...newRows[itemIndex], condition: condition };
      setRows(newRows);
    }
  };

  return (
    itsMaterialDialog.open && (
      <Dialog open={itsMaterialDialog.open} fullScreen>
        <div>
          {itsMaterialDialog.checkout ? (
            <ButtonGroup style={{ position: 'sticky', width: '100%', top: '0', zIndex: '100' }}>
              <Button
                onClick={() => {
                  dispatch(setItsMaterialDialog({ open: false, dataSet: '', checkout: false }));
                  setRows([]);
                }}
                variant="contained"
                style={{ width: '50%' }}
              >
                <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                  Затвори
                </Typography>
              </Button>
              <Button
                onClick={() => {
                  const validationError = validateInput();
                  if (validationError) {
                    dispatch(setSnackbar({ open: true, message: validationError }));
                    return;
                  }
                  saveItsMaterials(isInstaledMaterials);
                  dispatch(setItsMaterialDialog({ open: false, dataSet: '', checkout: false }));
                }}
                variant="contained"
                color="secondary"
                style={{ width: '50%' }}
              >
                <Typography gutterBottom component="span" style={{ fontSize: smallerFontSize }}>
                  Запази
                </Typography>
              </Button>
            </ButtonGroup>
          ) : (
            <></>
          )}
          <RASimpleForm toolbar={null} cardPadding="0px">
            {rows.map(x => (
              <div key={x.id}>
                {itsMaterialDialog.checkout && (
                  <>
                    <TextField
                      label={`Тип на материал ${x.id}`}
                      variant="standard"
                      style={{
                        marginLeft: '5px',
                        marginRight: '5px',
                        marginBottom: '6px',
                        padding: '0px',
                        textAlign: 'center',
                        display: 'flex',
                      }}
                      inputProps={{
                        style: { fontSize: smallerFontSize },
                      }}
                      margin="none"
                      value={x.materialTypeName}
                      onChange={event => saveMaterialTypeName(event, x.id)}
                    />
                    <TextField
                      label={`Сериен номер на материал  ${x.id}`}
                      variant="standard"
                      style={{
                        marginLeft: '5px',
                        marginRight: '5px',
                        marginBottom: '6px',
                        padding: '0px',
                        textAlign: 'center',
                        display: 'flex',
                      }}
                      inputProps={{
                        style: { fontSize: smallerFontSize },
                      }}
                      margin="none"
                      value={x.serialNumber}
                      onChange={event => saveMaterialSerialNumber(event, x.id)}
                    />
                    <TextField
                      label={`Състояние на материал  ${x.id}`}
                      variant="standard"
                      style={{
                        marginLeft: '5px',
                        marginRight: '5px',
                        marginBottom: '6px',
                        padding: '0px',
                        textAlign: 'center',
                        display: 'flex',
                      }}
                      inputProps={{
                        style: { fontSize: smallerFontSize },
                      }}
                      margin="none"
                      value={x.condition}
                      onChange={event => savеCondition(event, x.id)}
                    />
                  </>
                )}
                {rows.length === 1 ? (
                  <></>
                ) : (
                  <Chip
                    style={{
                      smallerFontSize,
                      marginLeft: '1vw',
                      margin: '2px',
                      marginTop: '1vh',
                      display: 'flex',
                    }}
                    avatar={<Remove />}
                    onClick={y => removeMaterial(x.id)}
                    clickable
                    label="Премахни материала"
                    color="secondary"
                  />
                )}
              </div>
            ))}
          </RASimpleForm>
        </div>
        <Chip
          style={{ display: 'flex', marginTop: '1vh' }}
          avatar={<Add />}
          onClick={event => {
            addMaterial();
          }}
          clickable
          label="Добави материал"
        />
      </Dialog>
    )
  );
};
